import { useQuery } from "@tanstack/react-query";
import apiInputService from "services/apiInputService";
import { ReprocessEvent } from "./@types";

const fetchReprocessMonitor = async (supplierCode?: string) => {
  const { data } = await apiInputService.get(
    `/activityReprocessor?/${
      supplierCode !== "none" ? "supplierCode=" + supplierCode : ""
    }`
  );

  return data as ReprocessEvent[];
};

export const useGetReprocessMonitorData = (
  supplierCode?: string,
  options?: any
) => {
  return useQuery<ReprocessEvent[]>(
    ["reprocess-monitor"],
    () => fetchReprocessMonitor(supplierCode),
    {
      ...options,
    }
  );
};
